import { lazy, Suspense } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../store';
import { closePanel } from '../../../../reducer/panel-slider';
import { BOOKING_COMPONENT } from '../../../../constants/panel-slider-components';
import PanelSlider from '../../../ui/pannel-slider';

const AppointmentBooking = lazy(() => import('../../../appointment-booking'));

const RightSidePanel = () => {
  const dispatch = useDispatch();

  const { open, UIComponent } = useSelector(
    (store: RootState) => store.panelSlider
  );

  return (
    <PanelSlider
      open={open}
      onClose={() => {
        dispatch(closePanel());
      }}
      style={{ width: '35vw' }}
      btnStyle={{ top: '30px' }}
    >
      <Suspense fallback={<div>loading...</div>}>
        {UIComponent === BOOKING_COMPONENT ? (
          <AppointmentBooking />
        ) : UIComponent === '' ? (
          <AppointmentBooking />
        ) : (
          <AppointmentBooking />
        )}
      </Suspense>
    </PanelSlider>
  );
};
export default RightSidePanel;
